<div class="container" style="margin-left: 50px;margin-right: 50px;">
    <router-outlet></router-outlet>
</div>
